/**
 * @author Hadeer Elbanna
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2020-10-25
 * @description Implementation of the external footer React component.
 * @filename external-footer.tsx
 */
import React from "react";
import LazyLoad from "react-lazyload";
import { Router } from "../../../utilities/router";
import { SVG } from "../../../component-configuration/svgs";
import { Disclaimer } from "../disclaimer";
const LOGO = require("../../../../static/rv-logo-on-black.png");

/**
 *  A React component that renders the footer.
 *
 * @export
 * @class ExternalFooter
 * @extends {React.Component<ExternalFooterProps, ExternalFooterState>}
 */
export class ExternalFooter extends React.Component<{}, {}> {
  /**
   * Returns a ReactNode containing the rendered component.
   *
   * @returns {React.ReactNode} The ReactNode containing the rendered component.
   */
  render(): React.ReactNode {
    return (
      <div className="external footer">
        <div className="row newDesign">
          <div className="col-xs-12 col-md-12">
            <LazyLoad once={true}>
              <img src={LOGO} alt="Radivision logo" className="logo d-inline-block" />
            </LazyLoad>
            <ul className="social-icons">
              <li>
                <a href="https://www.facebook.com/radivision/" target="_blank">
                  <button id="facebookIcon" className="btn-circle btn-lg">
                    {SVG.facebook}
                  </button>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/radivision/" target="_blank">
                  <button id="instagramIcom" className="btn-circle btn-lg">
                    {SVG.instagram}
                  </button>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/radivisiontv" target="_blank">
                  <button id="twitterIcon" className="btn-circle btn-lg">
                    {SVG.twitter}
                  </button>
                </a>
              </li>
              <li>
                <a href="https://www.linkedin.com/company/radivision/" target="_blank">
                  <button id="linkedinIcon" className="btn-circle btn-lg">
                    {SVG.linkedin}
                  </button>
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-md-12">
            <ul className="list-unstyled">
              <li>
                <a
                  onClick={() => {
                    Router.navigateTo("support", undefined, "faqs");
                  }}
                >
                  FAQs
                </a>
              </li>
              <li>
                <a
                  onClick={() => {
                    Router.navigateTo("support", undefined, "report-an-issue");
                  }}
                >
                  Report an Issue
                </a>
              </li>
              <li>
                <a href="https://www.radivision.com/">Radivision.com</a>
              </li>
              <li>
                <a
                  onClick={() => {
                    Router.navigateTo("legal", undefined, "terms-conditions");
                  }}
                >
                  Terms of Service
                </a>
              </li>
              <li>
                <a onClick={() => Router.navigateTo("legal", undefined, "privacy-policy")}>Privacy Policy</a>
              </li>
            </ul>
            <span className="copyrights content-right">© 2021 RADIVISION</span>
          </div>
        </div>
        <Disclaimer />
      </div>
    );
  }
}
